import { Dialog } from "@mui/material";
import { useState } from "react";
import { Icon } from "@iconify/react";
import {
  Box,
  HStack,
  VStack,
  ButtonPrimary,
  ButtonPrimary1,
} from "../../../../components/utils";
import { Input, Label } from "../../../../components/shared/InputField";

interface ResetWillingnessDialogProps {
  open: boolean;
  employeeName?: string;
  onClose: () => void;
  onSubmit: (reason?: string) => void;
  loading?: boolean;
}

export default function ResetWillingnessDialog({
  open,
  employeeName,
  onClose,
  onSubmit,
  loading,
}: ResetWillingnessDialogProps) {
  const [reason, setReason] = useState("");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <VStack className="">
        <div className="p-4 mt-4 text-lg font-medium border-b selection:ml-3 stone-700">
          <h6 className="flex justify-between">
            Reset Exercise Willingness
            <span onClick={() => onClose()} className="cursor-pointer">
              X
            </span>
          </h6>
        </div>
        <div className="p-4">
          <p className="text-sm text-gray-700 mb-3">
            Are you sure you want to reset the exercise willingness for{" "}
            <b>{employeeName || "this employee"}</b>?
          </p>
          <VStack className="p-2 text-black-501 bg-yellow-100 rounded">
            <HStack className="pt-0 justify-start">
              <HStack className="gap-1 pl-1 items-center">
                <Icon
                  icon="material-symbols:info-outline-rounded"
                  height={18}
                  width={18}
                  className="w-full text-xs font-medium text-black-501 rounded"
                />
                <p className="text-sm">Note</p>
              </HStack>
            </HStack>
            <Box className="pl-5 pt-2 pb-1">
              <ul className="list-disc">
                <li className="text-xs pt-0.5">
                  Reset their offer back to Offered state
                </li>
                <li className="text-xs pt-0.5">
                  Clear their submitted willingness and tax details
                </li>
                <li className="text-xs pt-0.5">
                  Delete any generated exercise letter(s)
                </li>
                <li className="text-xs pt-0.5">
                  The employee will need to re-submit their willingness
                </li>
              </ul>
            </Box>
          </VStack>
        </div>
        <div className="p-4">
          <Label className="mr-10 text-sm font-normal whitespace-nowrap">
            Reason for reset (optional)
          </Label>
          <Input
            placeholder="e.g. Employee requested a change in quantity"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
        <HStack className="justify-between gap-2 p-4">
          <ButtonPrimary1 onClick={onClose} disabled={loading}>
            Cancel
          </ButtonPrimary1>
          <ButtonPrimary
            onClick={() => onSubmit(reason)}
            loading={loading}
            className=""
          >
            Reset Willingness
          </ButtonPrimary>
        </HStack>
      </VStack>
    </Dialog>
  );
}
